import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { isLoggedIn } from "utils";

export const getVastuDengiList = async (data) => {
  return decryptData(
    await axios.get(
      `/getVastuDengiList?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const addVastuDengi = async (data) => {
  return decryptData(
    await axios.post(`/addVastuDengi`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const getVastuDengiById = async (data) => {
  return decryptData(
    await axios.get(
      `/getVastuDengiById?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const updateVastuDengi = async (data) => {
  return decryptData(
    await axios.post(`/updateVastuDengi`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
